import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Chart, ChartOptions, ChartDataset } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

import DatalabelsPlugin from 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-chart-dashboard',
  templateUrl: './chart-dashboard.component.html',
  styleUrls: ['./chart-dashboard.component.scss'],
  standalone: false,
})
export class ChartDashboardComponent implements OnInit {
  @Input() cColors: string[] = [];
  @Input() cLabels: string[];
  @Input() cType: string;
  @Input() cData: any = null;
  @Input() cMaxY?: number;
  @Input() cMaxX?: number;
  @Input() cStepSize?: number = 0;
  @Input() cIndexAxis?: 'x' | 'y';
  @Input() cShowChartOptions: boolean = true;
  @Input() cDecimalLabel: boolean = false;
  @Input() cChartTypes: any = ['pie', 'bar', 'line'];

  @Input() useHalfContainer: boolean;
  @Input() overrideHeight: number;

  cDataPercentage: any[];

  pieChartLegend: boolean = true;

  showPieChart: boolean;

  chartChanged: boolean = false;

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  chartData: ChartDataset[] = [];

  public pieChartPlugins = [DatalabelsPlugin];

  chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxis: {
        display: false,
        grid: {},
      },
      yAxis: {
        display: false,
      },
    },
    plugins: {
      legend: {
        display: true,
      },

      datalabels: {
        display: true,
        font: { size: 11 },
        color: '#000000',
        textShadowBlur: 0.1,
        textShadowColor: '#000000',
        anchor: 'end',
        align: 'start',
        formatter: (value, dnct1) => {
          if (this.cType === 'pie') {
            let sum = 0;
            let dataArr = dnct1.chart.data.datasets[0].data;
            dataArr.map((data) => {
              sum += Number(data);
            });

            let percentage = ((value * 100) / sum).toFixed(2) + '%';
            return percentage;
          } else {
            if (dnct1.dataset.order == 0) return null;
            if (this.cDecimalLabel == true) return Number(value).toFixed(2);
            return Math.round(Number(value));
          }
        },
      },

      tooltip: {
        backgroundColor: 'white',
        displayColors: false,
        padding: 10,
        titleColor: '#2D2F33',
        titleFont: {
          size: 18,
        },
        bodyColor: '#2D2F33',
        bodyFont: {
          size: 13,
        },
      },
    },
  };

  constructor() {}

  ngOnInit() {
    this.chartOptions.indexAxis = this.cIndexAxis;

    if (this.cMaxY != null) {
      this.chartOptions.scales = {
        xAxis: {
          display: false,
          grid: {},
        },
        yAxis: {
          display: false,
          suggestedMax: this.cMaxY,
          suggestedMin: 0,
        },
        y: {
          min: 0,
          max: this.cMaxY,
          ticks: {
            stepSize: this.cStepSize,
          },
        },
      };
    }

    if (this.cMaxX != null) {
      this.chartOptions.scales = {
        xAxis: {
          display: false,
          suggestedMax: this.cMaxX,
          suggestedMin: 0,
          grid: {},
        },
        yAxis: {
          display: false,
        },
        x: {
          min: 0,
          max: this.cMaxX,
          ticks: {
            stepSize: this.cStepSize,
          },
        },
      };
    }

    Chart.register(ChartDataLabels);
    this.setUpConfig();
  }

  ngOnChanges() {
    this.chartOptions.indexAxis = this.cIndexAxis;
    if (this.cMaxY != null) {
      this.chartOptions.scales = {
        xAxis: {
          display: false,
          grid: {},
        },
        yAxis: {
          display: false,
          suggestedMax: this.cMaxY,
          suggestedMin: 0,
        },
      };
    }

    if (this.cMaxX != null) {
      this.chartOptions.scales = {
        xAxis: {
          display: false,
          suggestedMax: this.cMaxX,
          suggestedMin: 0,
          grid: {},
        },
        yAxis: {
          display: false,
        },
      };
    }
    Chart.register(ChartDataLabels);
    this.setUpConfig();
  }

  setUpConfig() {
    this.pieChartLegend = true;
    this.cData.forEach((item: any, index: number) => {
      if (index < this.cColors.length && !item.backgroundColor) {
        item.backgroundColor = this.cColors;
      }
    });

    this.chartData = [...this.cData];
    this.chart?.render();
  }
}
